<template>
  <div class="card__wrapper pa-3">
    <v-layout wrap>
      <v-flex xs12 sm8 style="display: flex;align-items: flex-start;flex-direction: column;gap:6px">
        <p class="my-auto primary--text font-weight-bold" style="word-break: break-all;">
          {{ data.name }}
        </p>
        <p class="my-auto primary--text font-weight-bold">
          Type:
          <span style="color:#737272;font-weight: normal;text-transform: capitalize;">{{
            data.contents.upload_type
          }}</span>
        </p>
        <p style="color:#737272;font-weight: normal;margin: 0;">
          Created : {{ data.created_timestamp | DateFormat('DD/MM/YYYY hh:mm A') }} by:
          {{ data.create_by }}
        </p>
      </v-flex>
      <v-flex
        xs12
        sm4
        style="display: flex; justify-content: space-between; align-items: end; flex-direction: column;gap:6px;"
      >
        <div class="text-xs-right" style="display: flex;gap:6px;">
          <v-btn fab outline color="primary" class="extra-small ma-0" @click="isDetail = !isDetail">
            <i :class="['fa', { 'fa-chevron-down': !isDetail }, { 'fa-chevron-up': isDetail }]"></i>
          </v-btn>
          <v-btn fab outline color="primary" class="extra-small ma-0" @click="$emit('delete')">
            <i class="fa fa-trash middle"></i>
          </v-btn>
        </div>
        <div class="text-xs-right mt-auto">
          <v-chip :color="colorBadge" text-color="white" small disabled>{{ textBadge }}</v-chip>
        </div>
      </v-flex>
      <template v-if="isDetail">
        <v-flex xs12>
          <v-divider class="my-3"></v-divider>
          <p class="my-auto primary--text font-weight-bold" style="text-transform: capitalize;">
            {{ data.contents.upload_type }}
          </p>
          <template v-if="['text'].includes(data.contents.upload_type)">
            <span
              style="color:#737272;font-weight: normal;text-transform: capitalize;word-break: break-all;"
              >{{ data.contents.text }}</span
            >
          </template>
          <template v-if="['file'].includes(data.contents.upload_type)">
            <a
              :href="data.contents.file_url"
              target="_blank"
              class="primary--text"
              style="font-weight: normal;word-break: break-all;"
              >{{ data.contents.file_url }}</a
            >
          </template>
          <template v-if="['website'].includes(data.contents.upload_type)">
            <v-layout style="flex-direction: column;">
              <a
                v-for="(item, index) in data.contents.urls"
                :key="`${data.id}_detail_${index}`"
                :href="item"
                target="_blank"
                class="primary--text"
                style="font-weight: normal;word-break: break-all;"
                >{{ item }}</a
              >
            </v-layout>
          </template>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isDetail: false
    }
  },
  computed: {
    colorBadge() {
      return (
        {
          upload_success: '#3DCD10',
          transform_failed: 'red',
          pending: '#7F7F7F'
        }[this.data.status] || '#7F7F7F'
      )
    },
    textBadge() {
      return (
        {
          upload_success: 'Success',
          transform_failed: 'Failed',
          pending: 'Pending'
        }[this.data.status] || 'Pending'
      )
    }
  }
}
</script>
<style lang="css" scoped>
.card__wrapper {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #ef8b73;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/gpt/GptConversationCard.vue